import styled from 'styled-components';
import {
  colors,
  spacings,
  fontSizes,
  fontWeights,
  borders
} from '../../styles/theme'

interface InputContainerProps {
  block: boolean,
  marginBotton: string,
  hasError: boolean,
}

export const InputContainer = styled.div<InputContainerProps>`
  position: relative;
  width:100%;
  max-width: ${props => props.block ? "100%" : "330px"};
  margin-bottom: ${props => props.marginBotton}px;
  font-family: 'DM Sans', sans-serif;

  .formField-input{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 53px;

    input.input-color-picker{
      position: absolute;
      right: 1rem;
      min-height: 40px;
      width: 40px;
      outline: none;
      border: none;
    }

    input.input-color-text {
      border: ${borders.xs} solid ${props => props.hasError ? colors.secondary_four : colors.neutral_medium};
      outline: none;
      width: 100%;
      padding: 16px;
      padding-right: 4rem;
      color: ${colors.neutral_darkest};
      font-weight: ${fontWeights.w700};
      font-size: ${fontSizes.sm};
      background: #FFFFFF;
      box-shadow: 0 0 0 30px #FFFFFF inset;
      -webkit-box-shadow: 0 0 0 30px #FFFFFF inset;
      transition: all 0.3s ease-out;
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -webkit-appearance: none;
      border-radius: ${borders.lg};

      &:not(:placeholder-shown){
        border: ${borders.xs} solid ${props => props.hasError ? colors.secondary_four : colors.primary};
      }

      &:read-only {
        border: ${borders.xs} solid ${colors.neutral_medium};
        color: ${colors.neutral_darker}
      }

      &:focus:not(:read-only) {
        border: ${borders.xs} solid ${props => props.hasError ? colors.secondary_four : colors.primary};
      }

      &::placeholder {
        color: transparent;
      }

      &:focus + label,
      &:not(:placeholder-shown) + label {
        top: 0%;
        font-size: ${fontSizes.sl};
        color: ${colors.neutral_darkest};
      }
    }

    label {
      pointer-events: none;
      position: absolute;
      top: 50%;
      left: 15px;
      padding: 0px ${spacings.xs};
      font-size: ${fontSizes.sm};
      color: ${colors.neutral_darkest};
      font-weight: ${fontWeights.w700};
      background: #FFFFFF;
      transform: translateY(-50%);
      transition: all 0.3s ease-out;
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
    }
    
  }

  span{
    position: absolute;
    width: 100%;
    padding-top: ${spacings.xs};
    padding-left: ${spacings.md};
    color: ${colors.neutral_darker};
    font-weight: ${fontWeights.w700};
    font-size: ${fontSizes.xs};

    &.error {
      color: ${colors.secondary_four}
    }
  }
`